module.exports = __webpack_public_path__ + "img/image6.bffaf4dd.webp";